import { Schema } from '@typings';

import { isSchemaField } from '../guards';

export const getNonNullishMetadata = (schema: Schema.AnyOf) => {
  const model = schema.children.find((schema) => {
    if (isSchemaField(schema)) {
      return schema.properties.type !== 'null';
    }

    return true;
  });

  if (schema.title) {
    return { title: schema.title, description: schema.description };
  }

  if (!model) {
    return { title: 'Non-Nullish' };
  }

  if (isSchemaField(model)) {
    return {
      title: model.properties.title,
      description: model.properties.description,
    };
  }

  return {
    title: model.title,
    description: model.description,
  };
};
